import { module } from 'modujs';
import { html } from '../utils/environment';
import gsap, { ScrollTrigger } from 'gsap/all';

gsap.registerPlugin(ScrollTrigger);

const CLASS = {
    OPEN: `has-menu-open`,
}

export default class extends module {
    constructor(m) {
        super(m);

        this.logo = this.$('logo')[0];

        if (this.logo) {
            this.header = gsap.to(this.logo, {
                scrollTrigger: {
                    trigger: document.body,
                    id: "header",
                    start: "top -" + window.innerWidth * 0.035,
                    end: '+=' + window.innerWidth * 0.035,
                    onEnter: () => {
                        this.logo.classList.add('is-hidden')
                    },
                    onLeaveBack: () => {
                        this.logo.classList.remove('is-hidden')
                    }
                }
            })
        }

    }

    openMenu() {
        html.classList.add(CLASS.OPEN)
    }

    closeMenu() {
        html.classList.remove(CLASS.OPEN)
    }

    destroy() {
        super.destroy()
        if (this.header) this.header.scrollTrigger.refresh()
    }
}
